import Api from '@common/services/api';

export const toggleMute = async (orgId: string, conversationId: string, shouldMute: boolean) => {
  return Api.post(`/v3/organisations/${orgId}/conversations/${conversationId}/${shouldMute ? 'mute' : 'unmute'}`);
};
